/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', () => {
  const readMoreBtn = document.querySelector(".mobile--readmore");

  readMoreBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const currentTarget = e.currentTarget;
    console.log(currentTarget);
    const descriptionElement = currentTarget.parentElement.querySelector('.SectionHeader__Description.Rte');

    // Toggle visibility of description
    descriptionElement.classList.toggle("show");
    // Updates the text
    if (currentTarget.innerText === languages.collectionReadMore) {
      currentTarget.innerText = languages.collectionReadLess;
    } else {
      currentTarget.innerText = languages.collectionReadMore;
    }
  });
});

// Update product item prices when color swatch is changed
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle color swatch changes directly
  function initColorSwatchPriceUpdates() {
    // Select all color swatch inputs
    const colorSwatchRadios = document.querySelectorAll('.ProductItem__ColorSwatchList .ColorSwatch__Radio');

    colorSwatchRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        const variantUrl = this.getAttribute('data-variant-url');
        if (!variantUrl) return;

        const productItem = this.closest('.ProductItem');
        if (!productItem) return;

        // Extract variant ID from URL
        const variantIdMatch = variantUrl.match(/variant=(\d+)/);
        if (!variantIdMatch) return;

        const variantId = variantIdMatch[1];

        // Fetch the variant data
        fetch(`/variants/${variantId}.js`)
            .then(response => response.json())
            .then(variant => {
              // Update the price
              updateProductItemPrice(productItem, variant);
            })
            .catch(error => console.error('Error fetching variant data:', error));
      });
    });
  }

  // Function to update the product item price
  function updateProductItemPrice(productItem, variant) {
    const priceList = productItem.querySelector('.ProductItem__PriceList');
    if (!priceList) return;

    // Format price according to Danish format (comma as decimal separator, kr after the price)
    function formatPrice(cents) {
      // Convert to number and divide by 100
      const price = cents / 100;

      // Format with comma as decimal separator and no trailing zeros
      let formattedPrice = price.toFixed(2).replace('.', ',').replace(',00', '');

      // Add currency symbol after the price with a space
      return formattedPrice + ' kr';
    }

    // Clear existing price content
    priceList.innerHTML = '';

    // Add the appropriate price elements
    if (variant.compare_at_price > variant.price) {
      // On sale
      const salePrice = document.createElement('span');
      salePrice.className = 'ProductItem__Price Price Price--highlight Text--subdued';
      salePrice.textContent = formatPrice(variant.price);

      const comparePrice = document.createElement('span');
      comparePrice.className = 'ProductItem__Price Price Price--compareAt Text--subdued';
      comparePrice.textContent = formatPrice(variant.compare_at_price);

      priceList.appendChild(salePrice);
      priceList.appendChild(comparePrice);
    } else {
      // Regular price
      const regularPrice = document.createElement('span');
      regularPrice.className = 'ProductItem__Price Price Text--subdued';
      regularPrice.textContent = formatPrice(variant.price);

      priceList.appendChild(regularPrice);
    }

    // Update unit price if it exists
    if (variant.unit_price_measurement) {
      const unitPriceContainer = productItem.querySelector('.ProductItem__UnitPriceMeasurement');
      if (unitPriceContainer) {
        const unitPrice = unitPriceContainer.querySelector('.UnitPriceMeasurement__Price');
        if (unitPrice) {
          unitPrice.textContent = formatPrice(variant.unit_price);
        }

        const referenceValue = unitPriceContainer.querySelector('.UnitPriceMeasurement__ReferenceValue');
        if (referenceValue) {
          referenceValue.textContent = variant.unit_price_measurement.reference_value;
          referenceValue.style.display = variant.unit_price_measurement.reference_value === 1 ? 'none' : '';
        }
      }
    }
  }

  // Initialize on page load
  initColorSwatchPriceUpdates();

  // Reinitialize when the page content changes (for AJAX-loaded sections)
  // document.addEventListener('shopify:section:load', initColorSwatchPriceUpdates);
});
